import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Label
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

class EngineSettings extends Component {
  constructor(props) {
    super(props);

    const {
      content,
      startScreen,
      selected
    } = this.props;

    const {
      screens,
      list,
      routes
    } = content;
    const [entryScreen] = screens;

    this.state = {
      entryScreen,
      startScreen,
      selectedSetting: selected,
      settings: list,
      screensButtonConfig: {
        start: {
          left: {
            destination: routes.left
          },
          center: {
            onClick: this.enterSettings
          },
          right: {
            destination: routes.right
          }
        },
        speeds: {
          left: {
            onClick: this.increment
          },
          center: {
            onClick: this.changeSelection
          },
          right: {
            onClick: this.decrement
          }
        }
      }
    };
  }

  shouldUpdateValue = ({ min, max }, newVal) => (newVal >= min && newVal <= max);

  enterSettings = () => {
    const { id, changeState } = this.props;
    changeState(id, 0);
  }

  increment = () => this.changeValue('increment');

  decrement = () => this.changeValue('decrement');

  changeValue = (action) => {
    const { selectedSetting, settings } = this.state;
    const currentSetting = { ...settings[selectedSetting] };
    let newVal;

    if (action === 'increment') {
      newVal = currentSetting.value + 50;
    } else if (action === 'decrement') {
      newVal = currentSetting.value - 50;
    }

    if (this.shouldUpdateValue(currentSetting, newVal)) {
      const { id, updateItem } = this.props;

      currentSetting.value = newVal;
      updateItem(id, currentSetting);
    }
  }

  changeSelection = () => {
    const { id, changeState } = this.props;
    const { selectedSetting, settings } = this.state;
    let newSetting = selectedSetting + 1;
    let startScreenNext = false;

    if (newSetting >= settings.length) {
      startScreenNext = true;
      newSetting = null;
    }

    changeState(id, newSetting, startScreenNext);
  }

  render() {
    const {
      startScreen,
      selectedSetting,
      settings,
      screensButtonConfig,
      entryScreen
    } = this.state;
    const config = (startScreen) ? 'start' : 'speeds';
    const buttonConfig = screensButtonConfig[config];
    const visibleSetting = settings[selectedSetting];

    return [
      <Display key="display">
        <Header>
          <HeaderText value={entryScreen.title} />
        </Header>
        <Content>
          {startScreen ?
            <Label name={entryScreen.data[0].label} /> :
            [
              <Label key={uuidv4()} name={visibleSetting.label} center />,
              <Label key={uuidv4()} name={`${visibleSetting.value}`} invert center />
            ]
          }
        </Content>
        <Footer>
          <DisplayButton src={`icon-xm-${startScreen ? 'left' : 'up'}-arrow`} />
          <DisplayButton src="icon-xm-enter" />
          <DisplayButton src={`icon-xm-${startScreen ? 'right' : 'down'}-arrow`} />
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

EngineSettings.defaultProps = {
  selected: null
};

EngineSettings.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  id: PropTypes.string.isRequired,
  startScreen: PropTypes.bool.isRequired,
  selected: PropTypes.number,
  updateItem: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired
};

export default EngineSettings;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/EngineSettings/EngineSettings.js